import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sj6dmdqsub: FaireBrandEntity = {
  token: "b_sj6dmdqsub",
  type: "brand",
  name: "Set Apart Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ecfd2970528396ecea07283e42a0ab08588246f7cf6688ff449faaf7962c57f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8c4527ede9ceaf4a97aaf5ef8c423766dd2cf96ebb6e24bbe32ecfd6abf43fa7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7ecfd2970528396ecea07283e42a0ab08588246f7cf6688ff449faaf7962c57f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8c4527ede9ceaf4a97aaf5ef8c423766dd2cf96ebb6e24bbe32ecfd6abf43fa7.jpeg",
  location: "MA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "the studio was established in 2016 by a new england mama of three working by day as a police department clinician, working after kiddo bedtime to make magic for you + all of your favorite humans. specializing in natural/vegan wellness, we use only the best ingredients to formulate natural skincare + body products you know + love. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.712Z",
    importedBy: "entity-db-cli",
  },
};
